import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Card,
  List,
  ListItem,
  ListItemPrefix,
  Typography,
} from "@material-tailwind/react"
import { NavLink, Link, useHistory, useLocation } from "react-router-dom"
// import Logo from "../../assets/logo.png";
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import {
  MdApproval,
  MdAutorenew,
  MdDashboard,
  MdOutlineDiscount,
  MdOutlinePolicy,
  MdPayments,
  MdReport,
  MdSettings,
  MdSpaceDashboard,
  MdWorkspacePremium,
} from "react-icons/md"
import { MdOutlinePhonelinkSetup } from "react-icons/md"
import { MdOutlineSecurity } from "react-icons/md"
import {
  FaClipboardUser,
  FaCoins,
  FaMapLocation,
  FaMoneyBillWave,
  FaRegHandshake,
  FaUserShield,
  FaUserTie,
  FaUsers,
  FaRegPaperPlane,
} from "react-icons/fa6"
import { TiPointOfInterestOutline } from "react-icons/ti"
import { GiCoins } from "react-icons/gi"
import {
  BiBuilding,
  BiChevronDown,
  BiChevronRight,
  BiMoneyWithdraw,
} from "react-icons/bi"
import { IoBriefcase, IoSettings } from "react-icons/io5"
import { FaTruckLoading } from "react-icons/fa"
import { AiOutlineTransaction } from "react-icons/ai"
import { RiChatNewFill, RiFundsLine } from "react-icons/ri"
import { TbDeviceMobileCog } from "react-icons/tb"
import { HiOutlineBuildingOffice2 } from "react-icons/hi2"
import { GET_ROLE_PERMISSIONS } from "../../GraphQl/queries"
import { useQuery } from "@apollo/client"
import { UserType } from "../../types/user"
import { DEFAULTPRIMARYCOLOR } from "../../util"
import { RootState } from "../../store/store"
import { useSelector } from "react-redux"
import { getColorCode } from "../../colorCodes"

export function SidebarContent() {
  // const userData = localStorage.getItem("user")
  const [logo, setLogo] = useState<string>("")
  const location = useLocation()
  const [colors, setColors] = useState<string[]>()

  const {
    companyId,
    roleId,
    token,
    usertype,
    user: stateUser,
  } = useSelector((state: RootState) => state.auth)



  const { data, loading } = useQuery(GET_ROLE_PERMISSIONS, {
    variables: {
      role_id: localStorage.getItem("role_id"),
    },
  })

  const history = useHistory()
  const [open, setOpen] = useState<string>(
    localStorage.getItem("sidebarOpen") ?? "0"
  )

  const handleOpen = (value: string) => {
    setOpen(open === value ? "0" : value)
    localStorage.setItem("sidebarOpen", open === value ? "0" : value)
  }

  const handleLogout = async () => {
    try {
      localStorage.clear()
      history?.push("/")
    } catch (error) {
      toast.error("Failed to log out")
    }
  }

  useEffect(() => {
    if (stateUser) {
      const data: UserType = stateUser

      if (data?.logo_url?.length! > 5) {
        setLogo(data?.logo_url!)
      }
      const colorCodes = getColorCode(data?.colors!)
      // console.log(colorCodes)
      setColors(colorCodes)
    }
  }, [stateUser])


  const CustomLink = ({ to, title, icon }: any) => {
    const isActive = location?.pathname === to;

    return (
      <Link to={to}>
        <ListItem
          style={{
            background: isActive ? "#4F46E5" : "transparent", // Indigo 600
            color: isActive ? "white" : "black",
          }}
          className={`text-sm capitalize hover:bg-indigo-100`}
        >
          <ListItemPrefix>{icon}</ListItemPrefix>
          {title}
        </ListItem>
      </Link>
    );
  };





  return (
    <Card
      style={{
        background: `white`,
        color: `${colors?.length! > 2 ? `${colors![2]}` : "white"}`,
      }}
      className="sidebar-container h-full overflow-y-scroll bg-black w-full max-w-[20rem] rounded-none  p-4"
    >
      <div className="mb-1 p-4 flex items-center justify-center">
        <img src={logo} alt="logo" className="w-full h-20 object-contain" />
      </div>
      <Typography className="text-black text-left mx-5 pb-2 text-lg font-bold">
        Welcome, {stateUser?.name}
      </Typography>
      <List>
        {usertype !== "staff" && (
          <>
            {/* <Link to="/dashboard">
              <ListItem
                style={{
                  background:
                    history?.location?.pathname === "/dashboard"
                      ? `${
                          colors?.length! > 1
                            ? `${colors![1]}`
                            : `${DEFAULTPRIMARYCOLOR}`
                        }`
                      : "",
                  color: `${colors?.length! > 2 ? `${colors![2]}` : "white"}`,
                }}
                className={` text-sm hover:${
                  colors?.length! > 1
                    ? `bg-${stateUser?.colors![1]?.toLowerCase()}-200`
                    : "bg-red-400"
                }  capitalize`}
              >
                <ListItemPrefix>
                  <MdDashboard />
                </ListItemPrefix>
                Overview
              </ListItem>
            </Link> */}

            <CustomLink
              to="/dashboard"
              title="Dashboard"
              icon={<MdDashboard />}
            />

            <Link to="/dashboard/client">
              <ListItem
                style={{
                  background:
                    location?.pathname === "/dashboard/client"
                      ? "#6366f1" : "", // Indigo
                    color: "black",
                }}
                className="text-sm hover:bg-indigo-200 capitalize"
              >
                <ListItemPrefix>
                  <FaUserTie />
                </ListItemPrefix>
                Client 360
              </ListItem>
            </Link>

            <Link to="/dashboard/policy">
              <ListItem
                style={{
                  background:
                    history?.location?.pathname === "/dashboard/policy"
                      ? "#6366f1" : "", // Indigo
                    color: "black",
                }}
                className="text-sm hover:bg-indigo-200 capitalize"
              >
                <ListItemPrefix>
                  <MdOutlinePolicy />
                </ListItemPrefix>
                Policy 360
              </ListItem>
            </Link>

            {/* <Link to={"/dashboard/policy"}>
              <ListItem
                style={{
                  background:
                    history?.location?.pathname === "/dashboard/policy"
                      ? `${
                          colors?.length! > 1
                            ? `${colors![1]?.toLowerCase()}`
                            : `${DEFAULTPRIMARYCOLOR}`
                        }`
                      : "",
                }}
                className={`${
                  history?.location?.pathname === "/dashboard/policy" &&
                  "bg-red-400"
                } text-sm hover:${
                  colors?.length! > 1
                    ? `bg-${colors![1]?.toLowerCase()}-400`
                    : "bg-red-400"
                } hover:text-white text-white capitalize -mt-1`}
              >
                <ListItemPrefix>
                  <MdOutlinePolicy />
                </ListItemPrefix>
                Policy 360
              </ListItem>
            </Link> */}

            {/* <Link to={"/dashboard/funding-approval"}>
              <ListItem
                style={{
                  background:
                    history?.location?.pathname ===
                    "/dashboard/funding-approval"
                      ? `${
                          colors?.length! > 1
                            ? `${colors![1]?.toLowerCase()}`
                            : `${DEFAULTPRIMARYCOLOR}`
                        }`
                      : "",
                }}
                className={` p-0 text-sm hover:${
                  colors?.length! > 1
                    ? `bg-${colors![1]?.toLowerCase()}-400`
                    : "bg-red-400"
                } hover:text-white py-2.5 ml-2 text-white capitalize`}
              >
                <ListItemPrefix>
                  <MdApproval strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                funding approval
              </ListItem>
            </Link> */}
            <List
              style={{ background: `white`, color: "black" }} 
              className={` -mt-1`}
            >
              <Accordion
                open={open === "8"}
                icon={
                  <BiChevronDown
                    strokeWidth={2.5}
                    className={`${
                      colors?.length! > 2 ? `${colors![2]}` : "white"
                    } mx-auto h-4 w-4 transition-transform ${
                      open === "8" ? "rotate-180" : ""
                    }`}
                  />
                }
              >
                <ListItem
                  style={{
                    background:
                      location?.pathname === "/dashboard/setup"
                        ? "#6366f1" : "", // Indigo
                    color: "white",
              }}
              className="p-0 text-sm hover:bg-indigo-200 capitalize"
                  selected={open === "8"}
                >
                  <AccordionHeader
                    onClick={() => handleOpen("8")}
                    className="border-b-0 p-1 py-3 text-sm capitalize"
                    style={{ color: "black" }}
                  >
                    <ListItemPrefix>
                      <FaRegHandshake
                        strokeWidth={3}
                        className={`h-3 w-5 ${
                          colors?.length! > 2 ? `${colors![2]}` : "white"
                        }`}
                      />
                    </ListItemPrefix>
                    <Typography className="text-sm mr-auto font-normal">
                      Replenishments
                    </Typography>
                  </AccordionHeader>
                </ListItem>
                <AccordionBody style={{ background: `#f3f4f6`, color: "black" }}
                //   className="py-1  capitalize"
                // >
                  className="p-0 z-50 ">
                    <Link to="/dashboard/make-Payments">
                      <ListItem
                        style={{
                          background:
                            location?.pathname === "/dashboard/make-Payments"
                              ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize font-normal"
                      >
                        <ListItemPrefix>
                          <FaCoins />
                        </ListItemPrefix>
                        Replenish or Clear
                      </ListItem>
                    </Link>
                    <Link to="/dashboard/agent-receipts">
                      <ListItem
                        style={{
                          background:
                            location?.pathname === "/dashboard/agent-receipts"
                              ?  "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize font-normal"
                      >
                        <ListItemPrefix>
                          <FaMoneyBillWave />
                        </ListItemPrefix>
                        Replenishment Receipts
                      </ListItem>
                    </Link>
           
            {/* </List> */}
                </AccordionBody>
              </Accordion>
            </List>
          </>
        )}


        <List style={{ background: `white`, color: "black" }} className="-mt-0.5">
          <Accordion open={["1", "2", "2.2"].includes(open)} icon={
            <BiChevronDown
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${["1", "2", "2.2"].includes(open) ? "rotate-180" : ""}`}
            />
          }>
            <ListItem
              style={{
                background: history?.location?.pathname === "/dashboard/setup" ? "#6366f1" : "", // Indigo
                color: "white",
              }}
              className="p-0 text-sm hover:bg-indigo-200 capitalize"
              selected={["1", "2", "11", "2.2"].includes(open)}
            >
              <AccordionHeader
                onClick={() => handleOpen("1")}
                style={{ color: "black" }}
                className="border-b-0 p-1 py-3 text-sm capitalize"
              >
                <ListItemPrefix><MdOutlinePhonelinkSetup /></ListItemPrefix>
                <Typography className="text-sm mr-auto font-normal">System Setup</Typography>
              </AccordionHeader>
            </ListItem>

            <AccordionBody style={{ background: `#f3f4f6`, color: "black" }} className="py-1 capitalize">
              <List className="p-0 z-50">
                <Link to="/dashboard/setup/branches">
                  <ListItem
                    style={{
                      background: history?.location?.pathname === "/dashboard/setup/branches" ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix><BiBuilding /></ListItemPrefix>
                    Branch
                  </ListItem>
                </Link>

                <Link to="/dashboard/setup/workgroups">
                  <ListItem
                    style={{
                      background: history?.location?.pathname === "/dashboard/setup/workgroups" ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix><FaClipboardUser /></ListItemPrefix>
                    Workgroup/Divisions
                  </ListItem>
                </Link>

                <Link to="/dashboard/setup/roles">
                  <ListItem
                    style={{
                      background: history?.location?.pathname === "/dashboard/setup/roles" ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix><MdSettings /></ListItemPrefix>
                    Roles & Permissions
                  </ListItem>
                </Link>

                <List className="-mt-1">
                  <Accordion open={open === "2"} icon={
                    <BiChevronDown
                      strokeWidth={2.5}
                      className={`mx-auto h-4 w-4 transition-transform ${open === "2" ? "rotate-180" : ""}`}
                      color="black"
                    />
                  }>
                    <ListItem
                      style={{
                        background: history?.location?.pathname === "/dashboard/setup" ? "#6366f1" : "",
                        color: "black",
                      }}
                      className="p-0 text-sm hover:bg-indigo-200 capitalize"
                      selected={open === "2"}
                    >
                      <AccordionHeader
                        onClick={() => handleOpen(open === "1" ? "2" : "1")}
                        style={{ color: "black" }}
                        className="border-b-0 p-1 py-3 text-sm capitalize"
                      >
                        <ListItemPrefix><TbDeviceMobileCog /></ListItemPrefix>
                        <Typography color="black" className="text-sm mr-auto font-normal">
                          App Users
                        </Typography>
                      </AccordionHeader>
                    </ListItem>

                    <AccordionBody style={{ background: ``, color: "white" }} className="py-1 capitalize">
                      <List className="p-0 z-50">
                        <Link to="/dashboard/setup/staff">
                          <ListItem
                            style={{
                              background: ["/dashboard/setup/staff", "/dashboard/setup/manage-staff"].includes(history?.location?.pathname)
                                ? "#6366f1"
                                : "",
                              color: "black",
                            }}
                            className="p-0 text-sm hover:bg-indigo-200 py-2.5 px-2 capitalize"
                          >
                            <ListItemPrefix>
                              <FaUserShield strokeWidth={3} className="h-3 w-5" />
                            </ListItemPrefix>
                            Staff
                          </ListItem>
                        </Link>

                        <Link to={"/dashboard/setup/agent"}>
                          <ListItem
                            style={{
                              background:
                                history?.location?.pathname ===
                                  "/dashboard/setup/agent" ||
                                history?.location?.pathname ===
                                  "/dashboard/setup/manage-agent"
                                  ? "#6366f1"
                                : "",
                              color: "black",
                            }}
                            className="p-0 text-sm hover:bg-indigo-200 py-2.5 px-2 capitalize"
                          >
                            <ListItemPrefix>
                              <HiOutlineBuildingOffice2
                                strokeWidth={3}
                                className="h-3 w-5"
                              />
                            </ListItemPrefix>
                            Agents
                          </ListItem>
                        </Link>

                      </List>
                    </AccordionBody>
                  </Accordion>
                </List>

                <Link to="/dashboard/setup/commissions">
                  <ListItem
                    style={{
                      background: ["/dashboard/setup/commissions", "/dashboard/setup/manage-commissions"].includes(history?.location?.pathname)
                        ? "#6366f1"
                        : "",
                      color: "black",
                    }}
                    className="p-0 text-sm hover:bg-indigo-200 py-2.5 px-3 capitalize -mt-2"
                  >
                    <ListItemPrefix>
                      <TiPointOfInterestOutline strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Commissions Setup
                  </ListItem>
                </Link>
                                {/* <Link to={"/dashboard/setup/tax"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/setup/tax"
                          ? `${
                              colors?.length! > 1
                                ? `${colors![1]?.toLowerCase()}`
                                : `${DEFAULTPRIMARYCOLOR}`
                            }`
                          : "",
                    }}
                    className={`p-0 text-sm hover:${
                      colors?.length! > 1
                        ? `bg-${colors![1]?.toLowerCase()}-400`
                        : "bg-red-400"
                    } hover:text-white py-2.5 ml-2 text-white capitalize`}
                  >
                    <ListItemPrefix>
                      <TiPointOfInterestOutline
                        strokeWidth={3}
                        className="h-3 w-5"
                      />
                    </ListItemPrefix>
                    Tax Setup
                  </ListItem>
                </Link> */}
                <Link to={"/dashboard/setup/funding"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/setup/funding"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize font-normal"
                  >
                    <ListItemPrefix>
                      <RiFundsLine strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Account funding
                  </ListItem>
                </Link>
                <Link to={"/dashboard/funding-approval"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/funding-approval"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize font-normal"
                  >
                    <ListItemPrefix>
                      <MdApproval strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    funding approval
                  </ListItem>
                </Link>
                <Link to={"/dashboard/sent-messages"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/sent-messages"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize font-normal"
                  >
                    <ListItemPrefix>
                      <FaRegPaperPlane strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    sent messages
                  </ListItem>
                </Link>

              </List>
            </AccordionBody>
          </Accordion>
        </List>


        <List style={{ background: `white`, color: "black" }} className="-mt-0.5">
          <Accordion
            open={open === "6"}
            icon={
              <BiChevronDown
                strokeWidth={2.5}
                className={`mx-auto h-4 w-4 transition-transform${
                  open === "6" ? "rotate-180" : ""
                }`}
              />
            }
          >
            <ListItem
              style={{
                background: history?.location?.pathname === "/dashboard/setup"? 
                "#6366f1" : "", // Indigo
                color: "white",
              }}
              className="p-0 text-sm hover:bg-indigo-200 capitalize"
              selected={open === "6"}
            >
              <AccordionHeader
                onClick={() => handleOpen("6")}
                style={{ color: "black" }}
                className="border-b-0 p-1 py-3 text-sm capitalize"
              >
                <ListItemPrefix>
                  <AiOutlineTransaction color="black" />
                </ListItemPrefix>
                <Typography className="text-sm mr-auto font-normal">
                  Technical Transactions
                </Typography>
              </AccordionHeader>
            </ListItem>
            <AccordionBody style={{ background: `#f3f4f6`, color: "black" }}
              className="py-1 capitalize"
            >
              <List className="p-0 z-50 ">
                <Link to={"/dashboard/quotations"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/quotations"
                          ?  "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaUsers />
                    </ListItemPrefix>
                    Saved Quotations
                  </ListItem>
                </Link>

                <Link to={"/dashboard/new-policy"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/new-policy"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <RiChatNewFill />
                    </ListItemPrefix>
                    New Policies
                  </ListItem>
                </Link>
                <Link to={"/dashboard/renewals"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/renewals"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <MdAutorenew />
                    </ListItemPrefix>
                    Renewed Policies{" "}
                  </ListItem>
                </Link>

                <Link to={"/dashboard/lapsed"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/lapsed"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <MdAutorenew />
                    </ListItemPrefix>
                    Lapsed Policies
                  </ListItem>
                </Link>

              
                {/* <Link to={"/dashboard/expired-policies"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/expired-policies"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <MdAutorenew />
                    </ListItemPrefix>
                    Expired Policies
                  </ListItem>
                </Link> */}
              </List>
            </AccordionBody>
          </Accordion>
        </List>

        <List style={{ background: `white`, color: "black" }} className="-mt-0.5"
        >
          <Accordion
            open={open === "3"}
            icon={
              <BiChevronDown
                strokeWidth={2.5}
                className={`mx-auto h-4 w-4 transition-transform ${
                  open === "3" ? "rotate-180" : ""
                }`}
              />
            }
          >
            <ListItem
              style={{
                background: history?.location?.pathname === "/dashboard/setup"? 
                "#6366f1" : "", // Indigo
                color: "white",
              }}
              className="p-0 text-sm hover:bg-indigo-200 capitalize"
              selected={open === "3"}
            >
              <AccordionHeader
                onClick={() => handleOpen("3")}
                style={{ color: "black" }}
                className="border-b-0 p-1 py-3 text-sm capitalize"
              >
                <ListItemPrefix>
                  <FaMoneyBillWave />
                </ListItemPrefix>
                <Typography
                  className="text-sm mr-auto font-normal"
                >
                  Financial Transaction
                </Typography>
              </AccordionHeader>
            </ListItem>
            <AccordionBody
              style={{ background: `#f3f4f6`, color: "black" }}
              className="py-1  capitalize"
            >
              <List className="p-0 z-50">
                <Link to={"/dashboard/taxes"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/taxes"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaMoneyBillWave />
                    </ListItemPrefix>
                    taxes
                  </ListItem>
                </Link>
                <Link to={"/dashboard/pending_commissions"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/pending_commissions"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaCoins />
                    </ListItemPrefix>
                    Pending Commissions
                  </ListItem>
                </Link>
                <Link to={"/dashboard/paid_commissions"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname ===
                        "/dashboard/paid_commissions"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaCoins />
                    </ListItemPrefix>
                    paid commissions
                  </ListItem>
                </Link>
        
          <Link to={"/dashboard/orders"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/orders"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaCoins />
                    </ListItemPrefix>
                    Payment orders
                  </ListItem>
                </Link>
                <Link to={"/dashboard/approvals"}>
                  <ListItem
                    style={{
                      background:
                        history?.location?.pathname === "/dashboard/approvals"
                          ? "#6366f1" : "",
                      color: "black",
                    }}
                    className="text-sm hover:bg-indigo-200 capitalize"
                  >
                    <ListItemPrefix>
                      <FaCoins />
                    </ListItemPrefix>
                    Payment approvals
                  </ListItem>
                </Link>
              </List>
            </AccordionBody>
          </Accordion>
        </List> 

        {/* <Link to={"/dashboard/reports"}>
          <ListItem
            style={{
              background:
                history?.location?.pathname === "/dashboard/reports"
                  ? `${colors?.length! > 1
                    ? `${colors![1]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`
                  }`
                  : "",
              color: `${colors?.length! > 2 ? `${colors![2]}` : "white"}`,
            }}
            className={` text-sm hover:${colors?.length! > 1
                ? `bg-${stateUser?.colors![1]?.toLowerCase()}-200`
                : "bg-red-400"
              } capitalize -mt-1`}
          >
            <ListItemPrefix>
              <MdReport />
            </ListItemPrefix>
            report
          </ListItem>
        </Link>  */}

        <CustomLink
          to="/dashboard/reports"
          title="Reports"
          icon={<MdReport />}
        />

        <CustomLink
          to="/dashboard/settings"
          title="Settings"
          icon={<IoSettings />}
        />

         {/* <Link to={"/dashboard/settings"}>
          <ListItem
            style={{
              background:
                history?.location?.pathname === "/dashboard/settings"
                  ? `${colors?.length! > 1
                    ? `${colors![1]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`
                  }`
                  : "",
              color: `${colors?.length! > 2 ? `${colors![2]}` : "white"}`,
            }}
            className={`text-sm hover:${colors?.length! > 1
                ? `bg-${stateUser?.colors![1]?.toLowerCase()}-200`
                : "bg-red-400"
              } e capitalize -mt-1`}
          >
            <ListItemPrefix>
              <IoSettings />
            </ListItemPrefix>
            settings
          </ListItem>
        </Link>  */}

        <div
          className={`hover:bg-${colors?.length! > 1 && stateUser?.colors![1]?.toLowerCase()
            }-200 rounded-xl items-start justify-start`}
        >
          <div className="h-0.5 w-fit  rounded-md" />
          <ListItem
            style={{
              color: `${colors?.length! > 1 ? `red` : "white"}`,
            }}
            onClick={handleLogout}
            className="hover:bg-transparent hover:text-black text-xs w-full"
          >
            <ListItemPrefix>
              <i className="fa fa-sign-out text-sm" aria-hidden="true"></i>
            </ListItemPrefix>
            Log Out
          </ListItem>
        </div>
      </List>
    </Card>
  )
}
